<template>

<div class="tree">

    <core-filter-advanced-builder-group :group="filter" :level="1" v-if="filter && filter.rules && filter.rules.length" />

    <div class="tree-prompt" v-if="!filter || !filter.rules || !filter.rules.length" v-on:click="onPromptClick">

        <p>Add your first rule to start building your advanced filter.</p>

        <button class="tree-button">Start</button>

    </div>

</div>

</template>

<script>

export default {

    props: ['filterName'],

    provide: function() {

        return {
            filterName: this.filterName
        }

    },

    computed: {

        filter: function() {

            var value = this.$store.getters['filter/' + this.filterName + '/advanced']

            if (value && typeof value === 'object' && !Array.isArray(value)) {

                return value

            }

            return null

        }

    },

    methods: {

        onPromptClick: function() {

            this.$pubsub.$emit('open.modal', {
                id: 'filterDirectory',
                filterName: this.filterName
            })

        }

    }

}

</script>

<style scoped>

.tree {
    padding: 0px;
}

.tree-prompt {
    color: #fff;
    font-size: 20px;
    text-align: center;
    padding: 16px;
    line-height: 20px;
    height: 100%;
    display: flex;
    align-items: center;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.is-mobile .tree-prompt {
    font-size: 16px;
    line-height: 18px;
    color: #343434;
}

.tree-prompt p {
    opacity: 0.75;
}

.tree-button {
    background-color: #4881bb;
    color: #fff;
    margin-top: 15px;
    font-size: 16px;
    font-weight: 400;
    padding: 0px 20px;
    border-radius: 4px;
    line-height: 40px;
}

</style>
